import { useEffect, useState } from 'react';

/**
 * Scroll Progress Bar Hook
 * Phase 3: Motion & Animation
 * Tracks page scroll progress and returns percentage
 */
export function useScrollProgress() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const calculateScrollProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;

      const scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;
      setScrollProgress(Math.min(Math.max(scrollPercentage, 0), 100));
    };

    calculateScrollProgress();
    window.addEventListener('scroll', calculateScrollProgress, { passive: true });

    return () => window.removeEventListener('scroll', calculateScrollProgress);
  }, []);

  return scrollProgress;
}

/**
 * Scroll Progress Bar Component
 * Displays a fixed progress bar at the top of the page
 */
export function ScrollProgressBar() {
  const progress = useScrollProgress();

  return (
    <div
      className="scroll-progress"
      style={{ width: `${progress}%` }}
      role="progressbar"
      aria-label="Page scroll progress"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
    />
  );
}
